import React, {useCallback, useMemo, useState} from "react";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import {ModalPortal} from "features/components/modal";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {connect} from "react-redux";
import {signupSuccess} from "features/pages/account/signup/selectors";
import {signupDone} from "features/pages/account/signup/reducer";
import "./index.scss";
import {Stepper, StepperStep} from "features/components/stepper";
import OnboardingProfile from "features/pages/account/onboarding/profile";
import {profileSaveLoading} from "store/reducer/user/profile/selectors";
import {saveProfileStart} from "store/reducer/user/profile/reducer";
import {onboardingCompleteLoading, onboardingIndex} from "features/pages/account/onboarding/selectors";
import {
    onboardingCompaniesComplete,
    onboardingCompleteStart,
    onboardingGoBack
} from "features/pages/account/onboarding/reducer";
import OnboardingCompany from "features/pages/account/onboarding/company";
import {myCompaniesSelector} from "store/reducer/company/selectors";
import {ADMIN_ROLE_KEY, TEST_PUBLIC_PROFILE} from "constants.js";
import {CompanyValidator} from "services/utils/validations";
import OnboardingRecap from "features/pages/account/onboarding/recap";
import logoWhite from "images/logo/marchio-bianco.svg";
import profileImage from "images/profile-onboarding.jpeg";
import {TutorialModal} from "features/modals/onboarding/tutorial";

/* istanbul ignore next */
const mapStateToProps = state => ({
    signupSuccess: signupSuccess(state),
    profile_save_loading: profileSaveLoading(state),
    companies: myCompaniesSelector(state),
    index: onboardingIndex(state),
    complete_loading: onboardingCompleteLoading(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    signupDone,
    saveProfile: saveProfileStart,
    goBack: onboardingGoBack,
    onboardingCompaniesComplete,
    onboardingCompleteStart
};

export const OnboardingPage = (props) => {
    const {signupDone, signupSuccess, index, profile_save_loading, saveProfile, goBack, companies, onboardingCompaniesComplete, onboardingCompleteStart,
        complete_loading} = props;

    const [profile, setProfile] = useState(false);

    const finishSignup = useCallback(() => {
        signupDone()
    }, [signupDone]);

    const showModal = useCallback(() => {
        if(!signupSuccess) return null
        return <ModalPortal className="signup-success-modal" horizontal={true} size={"large"}>
            <div className="content">
                <Title size={34}>{__("signup.step2.success-modal.title")}</Title>
                <Text size={16}>{__("signup.step2.success-modal.text")}</Text>
                <Button title={__("buttons.next")} onClick={finishSignup} icon={"arrow-right"} />
            </div>
            <div className="image">
                <img alt="modal-success" src={logoWhite} />
            </div>
        </ModalPortal>;
    }, [signupSuccess, finishSignup]);

    const goToTestProfile = useCallback(() => {
        window.open(TEST_PUBLIC_PROFILE, "_blank");
    }, []);

    const onboardingComplete = useCallback(() => {
        onboardingCompleteStart();
    }, [onboardingCompleteStart]);

    const profileComplete = useCallback(() => {
        const profileData = {
            ...profile
        }
        delete profileData.valid;
        saveProfile(profileData)
    }, [saveProfile, profile]);

    const companiesValid = useMemo(() => {
        return companies.length > 0 && companies.filter(i => i.role === ADMIN_ROLE_KEY).filter(i => !CompanyValidator(i)).length === 0
    }, [companies]);

    const companiesComplete = useCallback(() => {
        onboardingCompaniesComplete()
    }, [onboardingCompaniesComplete]);

    const [showTutorial, setTutorial] = useState(false);

    return <LoggedOutLayout
        type={"light"}
        showLogoutButton={true}
        className={"onboarding-page"}
        breadcrumbs={[{title: "onboarding.breadcrumb"}]}
    >
        {/*<div className="tutorial-button">
            <Button title={__("buttons.tutorial")} onClick={() => setTutorial(true)} type={"clear"}
                    icon={"comment-video"}/>
        </div>*/}
        {/*istanbul ignore next*/showTutorial && <TutorialModal onHide={() => setTutorial(false)} />}
        {showModal()}
        <div className="sidebar-wrapper">
            <div className="sidebar">
                <Title size={34}>{__("onboarding.sidebar.title")}</Title>
                <Text size={16}>{__("onboarding.sidebar.text")}</Text>
                <div className="example">
                    <Title size={18}>{__("onboarding.sidebar.example.title")}</Title>
                    <div className="row">
                        <div className="row">
                            <img alt={"example user"} src={profileImage} />
                            <div>
                                <Text size={14}>{__("onboarding.sidebar.example.name")}</Text>
                                <Text size={12}>{__("onboarding.sidebar.example.job")}</Text>
                            </div>
                        </div>
                        <Button title={__("buttons.go-to-profile")} onClick={goToTestProfile} type={"clear"} size={"small"} />
                    </div>
                </div>
            </div>
            <div className="content">
                <Stepper startIndex={index} onComplete={onboardingComplete} onBack={() => goBack()}>
                    <StepperStep stepperDoneFunc={profileComplete} stepperValidation={() => !!profile.valid} stepperLoading={profile_save_loading}>
                        <OnboardingProfile onChange={setProfile} />
                    </StepperStep>
                    <StepperStep stepperValidation={() => companiesValid} stepperDoneFunc={companiesComplete}>
                        <OnboardingCompany />
                    </StepperStep>
                    <StepperStep stepperTitle={__("buttons.profile-complete")} stepperLoading={complete_loading}>
                        <OnboardingRecap />
                    </StepperStep>
                </Stepper>
            </div>
        </div>

    </LoggedOutLayout>
}
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPage);